<script>
export default {
  name: "Underline",
}
</script>

<template>
  <span class="flex w-20 h-1.5 mt-4 mb-8"></span>
</template>